import { fetch } from '../utils/fetch';

/**
 * 查询列表
 * @returns {Promise<Response>}
 */
export function _queryInvitations(
  {
    page, size, direction, sort,
  },
) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/invitation`,
    method: 'get',
    params: {
      page,
      size,
      direction,
      sort,
    },
  });
}

/**
 * 根据 id 查询
 * @returns {Promise<Response>}
 */
export function _queryInvitation(id) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/invitation/${id}`,
    method: 'get',
  });
}

/**
 * 新增
 * @param  title
 * @param  content
 * @param  code
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _addInvitation(
  {
    title,
    content,
    code,
    type,
  },
) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/invitation`,
    method: 'post',
    data: {
      title,
      content,
      code,
      type,
    },
  });
}

/**
 * 更新
 * @private
 */
export function _updateInvitation(id, {
  status,
  reason,
}) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/invitation/${id}`,
    method: 'patch',
    data: {
      status,
      reason,
    },
  });
}

/**
 * 删除
 * @param appInfoId
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _deleteInvitation(id) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/invitation/${id}`,
    method: 'delete',
  });
}

/**
 * 改变审核状态
 */
// export function _updateInvitation(id) {
//   return fetch({
//     url: `${process.env.VUE_APP_BASE_URL}/invitation/${id}/status`,
//     method: 'patch',
//   });
// }

export default {};
